module.exports = __webpack_public_path__ + "img/file04.fdfb2673.png";